import { ReturnsAndClaimsPermissions } from "@redotech/account-common/permissions";
import { RedoSecondaryNavItem } from "@redotech/arbiter/navigation/secondary/redo-secondary-nav-item";
import { useRequiredContext } from "@redotech/react-util/context";
import { useTranslation } from "@redotech/redo-i18n";
import GiftIcon from "@redotech/redo-icons/gift-01.svg";
import GiftFilledIcon from "@redotech/redo-icons/gift-01_filled.svg";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { memo } from "react";
import { useMatch } from "react-router-dom";

/** In the new experience this is its own nav item, not a tab on the returns table. */
export const GiftReceiptRequestsItem = memo(function GiftReceiptRequestsItem() {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  const team = useRequiredContext(TeamContext);
  const canView = useHasPermission(ReturnsAndClaimsPermissions.VIEW_RETURN);
  const href = routes.getReturnsSubRoute("gift-receipt-requests");
  const selected = useMatch(`${href}/*`);

  if (!canView || !team?.settings.returns?.enableGiftReceipts) {
    return null;
  }

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href }}
      data-dd-action-name="returns_nav:gift_receipt_requests_link_click"
      FilledIcon={GiftFilledIcon}
      friendlyName={t("Gift receipt requests")}
      id="gift-receipt-requests"
      selected={!!selected}
      UnfilledIcon={GiftIcon}
    />
  );
});
